import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'salutation',
  standalone: true
})
export class SalutationPipe implements PipeTransform {

  transform(salutation: any): string {
    if (typeof salutation != 'string' || !salutation.trim()) {
      return '';
    }

    const normalized = salutation.trim().replace('.', '').toLowerCase();

    const maleSalutations = ['herr', 'hr', 'mr'];
    const femaleSalutations = ['frau', 'fr', 'ms'];

    if (maleSalutations.includes(normalized)) {
      return 'salutation.mr';
    } else if (femaleSalutations.includes(normalized)) {
      return 'salutation.ms';
    } else {
      return salutation;
    }
  }
}
